import { Box, BoxProps, Spacer, Text } from '@jfs/ui-new'
import { FC, useState } from 'react'
import { Clipboard } from 'react-native'
import { Checkbox, CheckBoxTypes } from '../../../../comps/Checkbox'
import { SvgImage } from '../../../../comps/SvgImage'
import { MerchantType } from '../../../../data/models/Merchant'
import { staticStrings } from '../../../../data/static/strings'
import { styles1 } from './styles'
interface MIDListItemProps {
  data: MerchantType
  selectedMid: string
  selectedCheckbox: string
  onPress: () => void
  breakpoint: number
  onCopy: any
}
const MIDListItem: FC<MIDListItemProps> = ({
  data,
  selectedMid,
  selectedCheckbox,
  onPress,
  breakpoint,
  onCopy,
}: MIDListItemProps) => {
  const [isHovering, setIsHovering] = useState(false)
  const handleHover = (hovering: boolean): void => {
    setIsHovering(hovering)
  }

  const themedStyle = styles1(breakpoint)
  const merchant: any = data

  if (merchant.mid === selectedMid) {
    return null
  }

  const getHoverStyle = (): BoxProps => {
    if (isHovering && merchant.isValidMerchant()) {
      return styles1(breakpoint).hoverState
    }
    return {}
  }
  const hoverStyle = getHoverStyle()
  const getCheckboxState = (): boolean => {
    if (selectedCheckbox === merchant.id) {
      return true
    }
    return false
  }

  const getDisableState = (): boolean => {
    if (
      (merchant.status.toUpperCase() === staticStrings.activeStatus.toUpperCase() ||
        merchant.status.toUpperCase() === staticStrings.hotMerchantStatus.toUpperCase()) &&
      merchant.userStatus.toUpperCase() === staticStrings.activeStatus.toUpperCase()
    ) {
      return false
    }

    return true
  }

  const getTextColor = () => {
    if (getDisableState()) {
      return 'PRIMARY_GREY'
    }
    return 'BLACK'
  }
  const getFontWeight = () => {
    if (getDisableState()) {
      return '600'
    }
    return '800'
  }

  const getContainerStyle = (): BoxProps => {
    if (merchant.isValidMerchant()) {
      return themedStyle.cellContainer.enabled
    }
    return themedStyle.cellContainer.disabled
  }

  const handleCopy = () => {
    Clipboard.setString(merchant?.mid)
    onCopy('Content copied to clipboard')
  }
  return (
    <Box underlayColor="TRANSPARENT" onPress={() => null} onHover={handleHover}>
      <Box
        underlayColor="TRANSPARENT"
        disabled={getDisableState()}
        onPress={onPress}
        testID={`mid-list-${merchant?.mid}`}
        {...getContainerStyle()}
        {...hoverStyle}>
        <Box pl={0} underlayColor="TRANSPARENT" justifyContent="center" alignSelf="flex-start" pt={4}>
          <Checkbox
            type={CheckBoxTypes.ROUNDED}
            disabled={getDisableState()}
            isChecked={getCheckboxState()}
            onPress={onPress}
            size={16}
            // Todo
            color={'#034EA8'}
          />
        </Box>
        <Spacer size={16} direction="horizontal" />
        <Box w={232}>
          <Text color={getTextColor()} fontFamily="jiotype-bold" fontWeight={getFontWeight()} numberOfLines={1}>
            {`${merchant.businessName}`}
          </Text>
          <Spacer size={5} />
          <Box
            flexDirection={'row'}
            align={'center'}
            gap={8}
            testID="copy-mid"
            onPress={handleCopy}
            underlayColor={'TRANSPARENT'}>
            <Text color="LIGHT_BLACK" fontWeight="bold" fontSize={10}>
              {/* {`MID: ${merchant?.mid} | TID: ${merchant?.tId}`} */}
              {`MID: ${merchant?.mid}`}
            </Text>
            <SvgImage imageName={'copy'} width={10} height={10} />
          </Box>
          <Spacer size={7} />
          <Box {...themedStyle.cellStatusView[merchant.merchantStatusString()]}>
            <Text {...themedStyle.cellStatusValue}>{merchant?.merchantStatusString()}</Text>
          </Box>
        </Box>
      </Box>
    </Box>
  )
}

export { MIDListItem }
